import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import { AppConfigService } from '../../app.config';
import { DisplayModes } from '../../models/enums';
import { AccountService } from '../../services/account.service';
import { VisitTypesService } from './visit-types.service';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { Permission } from '../../../app/models/permission.model';


@Component({
  selector: 'crm-visit-types',
  templateUrl: './visit-types.component.html',
  styleUrls: ['./visit-types.component.css']
})
export class VisitTypesComponent implements OnInit {

  visitTypes: any[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  searchText: string;
  pageSize: number;
  public logo = require("../../../app/assets/images/demo/Icon_Items Format.png");

  selectedVisitTypeId;
  addNew: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly visitTypesService: VisitTypesService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getVisitTypes();
  }

  getVisitTypes() {
    this.displayMode = DisplayModes.Loading;
    this.visitTypesService.search(this.searchText).subscribe(responce => {
      this.visitTypes = responce as any[];
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get visitTypes');
        console.log(err);
      })

  }

  gotoNew() {
    this.addNew = true;
  }

  edit(id) {
    this.selectedVisitTypeId = id;
    this.addNew = true;
  }

  confirmDelete(visitType) {
    this.selectedVisitTypeId = visitType;
    this.deleteModal.show();
  }

  delete() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.visitTypesService.delete(this.selectedVisitTypeId.id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("clm.deletedSuccessfully"), MessageSeverity.Success);

      let index = this.visitTypes.indexOf(this.selectedVisitTypeId);
      this.visitTypes.splice(index, 1);
    }, error => {
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while delete item fromat:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  get canManageVisitTypes() {
    return this.accountService.userHasPermission(Permission.manageVisitTypesPermission);
  }

  closeAdding(event) {
    this.selectedVisitTypeId = undefined;
    this.addNew = false;
    if (event) {
      this.getVisitTypes();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }


}
